// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"520":"7290aee6","815":"bffea6ff"}[chunkId] + ".css";
};